export type ResearchHandoff = {legacyRetired:true;targets:Array<{sectorId:number;categoryPath:string}>};
type Job = {
  status:string; sectorId:number; siteId:string; targetMode?:string;
  targets:Record<string,string>; progressDetails?:unknown; handoff?:ResearchHandoff|null;
};
function unknownOutcome(value:unknown):boolean {
  return !!value && typeof value==='object' &&
    (('status' in value && value.status==='outcome_unknown') || Object.values(value).some(item=>item==='outcome_unknown'||unknownOutcome(item)));
}
export function researchJobHasCatalogScope(job:Job|null):boolean {
  return !!job && job.targetMode==='catalog_full_path' && Object.keys(job.targets).length>0
    && Object.values(job.targets).every(path=>typeof path==='string' && path.trim()===path && path.length>0);
}
export function researchJobRetired(job:{handoff?:ResearchHandoff|null}|null):boolean {
  return job?.handoff?.legacyRetired===true && job.handoff.targets.length>0;
}
function handedOff(job:Job,sectorId:number,path:string):boolean {
  return researchJobRetired(job) && job.handoff!.targets.some(target=>target.sectorId===sectorId && target.categoryPath===path);
}
export function researchJobBlocks(job:Job):boolean {
  if(researchJobHasCatalogScope(job) && Object.values(job.targets).every(path=>handedOff(job,Number(job.sectorId),path)))return false;
  const progress=job.progressDetails as Record<string,{steps?:Record<string,string>}>|undefined;
  return ['pending','running','paused'].includes(job.status) || unknownOutcome(progress)
    || ['completed','failed','cancelled'].includes(job.status) && Object.values(progress||{}).some(category=>Object.values(category.steps||{}).includes('running'));
}
export function researchJobsOverlap(jobs:Job[],sectorId:number,paths:string[]):boolean {
  return paths.length>0 && jobs.some(job=>researchJobBlocks(job) && Number(job.sectorId)===sectorId
    && paths.some(path=>!handedOff(job,sectorId,path) && (!researchJobHasCatalogScope(job) || Object.values(job.targets).includes(path))));
}
